import SellerBoxLogoColumn from '@/assets/icons/Login/Group_2768.svg?react';
import { useNavigate } from 'react-router-dom';
import PhoneLogo from '@/assets/icons/Login/eva_phone-fill.svg?react';
import { ROUTES } from '@/routes';

const NophoneKakaoLogin = () => {
  const navigate = useNavigate();

  return (
    <div className=" flex w-full flex-col items-center rounded-[20px] border bg-white py-[88px] pt-[120px] text-center">
      <div className="mb-[28px] flex flex-col items-center gap-[32px] rounded-[20px] border p-[30px]">
        <SellerBoxLogoColumn />

        <div className="Title3S18">로그인을 실패했습니다</div>
        <div className="flex justify-center text-gr-700 Body5M14">
          카카오 계정에 전화번호를 등록 후 <br />
          재로그인을 시도해주세요
        </div>
        <div className="flex flex-col gap-2">
          <button
            onClick={() => navigate(`${ROUTES.signin}?ctab=phone`)}
            className="flex h-[44px] w-[320px] items-center justify-center gap-[10px] rounded-[8px] bg-gr-100 text-gr-700 Body5M14"
          >
            <PhoneLogo />
            핸드폰 번호로 시작하기
          </button>
        </div>
      </div>
    </div>
  );
};

export default NophoneKakaoLogin;
